<svg class="{$$props.class}" viewBox="0 0 512 512">
  <path
    fill="currentColor"
    d="M502.3 190.8a6 6 0 019.7 4.7V400a48 48 0 01-48 48H48a48 48 0
    01-48-48V195.6a6 6 0 019.7-4.7c22.4 17.4 52.1 39.5 154.1 113.6 21.1 15.4
    56.7 47.8 92.2 47.6 35.7.3 72-32.8 92.3-47.6 102-74.1 131.6-96.3
    154-113.7zM256 320c23.2.4 56.6-29.2 73.4-41.4 132.7-96.3 142.8-104.7
    173.4-128.7A24 24 0 00512 131v-19a48 48 0 00-48-48H48a48 48 0 00-48 48v19a24
    24 0 009.2 18.9c30.6 23.9 40.7 32.4 173.4 128.7 16.8 12.2 50.2 41.8 73.4
    41.4z" />
</svg>
